import { render, staticRenderFns } from "./idolSupplementCreateGoodsOrder.vue?vue&type=template&id=1b9c5682&scoped=true"
import script from "./idolSupplementCreateGoodsOrder.vue?vue&type=script&lang=ts"
export * from "./idolSupplementCreateGoodsOrder.vue?vue&type=script&lang=ts"
import style0 from "./idolSupplementCreateGoodsOrder.vue?vue&type=style&index=0&id=1b9c5682&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c5682",
  null
  
)

export default component.exports